import BeardError from "./BeardError";
import BeardItemCard from "./BeardItemCard"

export default function BeardNotificationsList({ items = [], error = undefined }) {
    function handleAction(e, item, action) {
        e.preventDefault();

        if (action.slice(0, 1) === '/') window.location = action;
        if (action === 'view') window.location = `/flights/${item.id}`;
        if (action === 'data') window.location = `/flights/data/${item.id}`;

        if (action === 'delete') {
            setIsSubmitting(true)
            requestAction.deleteRequest(item.id)
                .then(response => {
                    if (response.status === 'success') {
                        fetch();
                    }
                })
                .finally(() => {
                    setIsSubmitting(true)
                })
        }
    }

    return <React.Fragment>
        {error && <BeardError message={__('[Beard] Fetching error text')} />}
        {items.length > 0 && items.map(item => <BeardItemCard key={`${item.id}-${item.code}`} item={item} onActionPress={handleAction} />)}
    </React.Fragment>
}
